import React from 'react';
import {TextInput} from 'src/lib/components/TextInput.component';

export function ThresholdRangeInput({
  label,
  description,
  upperRef,
  lowerRef,
  upperDefaultValue,
  lowerDefaultValue,
  disabled = false,
}: {
  label: string;
  description: string;
  upperRef: React.RefObject<HTMLInputElement>;
  lowerRef: React.RefObject<HTMLInputElement>;
  upperDefaultValue?: string;
  lowerDefaultValue?: string;
  disabled?: boolean;
}) {
  return (
    <div className="grid basis-full grid-cols-[minmax(10rem,1.25fr)_minmax(0,1fr)_minmax(0,1fr)] items-end gap-4">
      <div className="pb-2">
        <div className="text-sm font-normal text-gray-900 dark:text-white">{label}</div>
        <div className="mt-1 text-[11px] text-gray-600 dark:text-gray-300">{description}</div>
      </div>
      <TextInput
        labelProps={{children: '上限'}}
        type="number"
        step="any"
        containerProps={{className: 'min-w-0'}}
        defaultValue={upperDefaultValue}
        disabled={disabled}
        ref={upperRef}
      />
      <TextInput
        labelProps={{children: '下限'}}
        type="number"
        step="any"
        containerProps={{className: 'min-w-0'}}
        defaultValue={lowerDefaultValue}
        disabled={disabled}
        ref={lowerRef}
      />
    </div>
  );
}
